import i18n from '../i18n';
import {validateIBAN} from "ibantools";

const getIn = (obj, path) =>
  path.split('.').reduce((acc, key) => (acc == null ? acc : acc[key]), obj);


export const WithdrawalFundsValidation = values => {
  const errors = {};
  const requiredFields = [
    'firstName',
    'lastName',
    'address.city',
    'address.street',
    'address.buildingNumber',
    'countryCode',
    'accountNumber',
    'amount',
  ];


  if (values.accountNumber) {
    const iban = `${values.countryCode}${values.accountNumber.replaceAll(/\D/g, '').replaceAll(' ', '').trim()}`
    const ibanValid = validateIBAN(iban)
    if (!ibanValid.valid) {
      if (ibanValid.errorCodes.includes(1) && ibanValid.errorCodes.length === 1) {
        errors.accountNumber = i18n.t('withdrawalFunds.error.wrongIbanPrefix');
      } else {
        errors.accountNumber = i18n.t('withdrawalFunds.error.wrongIban');
      }
    }
  }

  requiredFields.forEach((field) => {
    const v = getIn(values, field);
    const isEmpty =
      v === undefined || v === null || (typeof v === 'string' && v.trim() === '');
    if (isEmpty || (field === 'amount' && (v === 0 || v === '0'))) {
      if (field.indexOf('.') !== -1) {
        const parts = field.split('.');
        const root = parts[0];
        const rest = parts.slice(1);

        if (!errors[root]) errors[root] = {};
        let cursor = errors[root];

        for (let i = 0; i < rest.length - 1; i++) {
          const k = rest[i];
          if (!cursor[k]) cursor[k] = {};
          cursor = cursor[k];
        }
        cursor[rest[rest.length - 1]] = i18n.t('common.validation.required');
      } else {
        errors[field] = i18n.t('common.validation.required');
      }
    }
  });

  if (values['countryCode'] !== "PL") {
    if (!values['swift']) {
      errors['swift'] = i18n.t('common.validation.required');
    }
  }

  return errors;
};
